import { render, staticRenderFns } from "./OsechiNote.vue?vue&type=template&id=24fdc18e&scoped=true"
import script from "./OsechiNote.vue?vue&type=script&lang=js"
export * from "./OsechiNote.vue?vue&type=script&lang=js"
import style0 from "./OsechiNote.vue?vue&type=style&index=0&id=24fdc18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fdc18e",
  null
  
)

export default component.exports